export const environment = {
    production: true,
    logErrorInConsole: true,
    environmentName: "staging",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    preferredDateFormat: "yyyy-MM-dd HH:mm:ss",
    oauthBaseAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/auth/",
    usersAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/users/",
    rolesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/roles/",
    organizationsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/organizations/",
    profileAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/profile/",
    resetPasswordAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/resetpassword/",
    languagesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/languages/",
    smtpMailAccountsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/mailaccounts/",
    mailtemplatesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/mailtemplates/",
    firebaseConfigAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/firebaseconfig/",
    firebaseDevicesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/firebasedevices/",
    firebaseNotificationsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/firebasenotifications/",
    firebaseNotificationTemplatesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/firebasenotificationtemplates/",
    systemLogMessagesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/systemlogs/",
    systemJobPerformancesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/systemjobs/",
    systemResourceSnapshotsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/systemresource/",
    systemErrorsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/systemerrors/",
    postcodeAreasAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/postcodeareas/",
    postcodeUsersAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/postcodeusers/",
    flyerImagesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/flyerimages/",
    checklistsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/checklists/",
    checklistTemplateAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/checklisttemplates/",
    interestedPartiesAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/interestedparties/",
    distributorsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/distributors/",
    shopItemsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/shopitems/",
    orderItemsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/orderitems/",
    visitReportsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/admin/visitreports/",
    toursAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/admin/tours/",
    googleMapsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/admin/googlemaps/",
    salesManagerShopItemsAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/admin/salesmanagershopitems/",
    salesManagerOrdersAPI: "https://testwww.conmoto.vcl4.kunden.csl.de/api/v1/admin/salesmanagerorders/"
};
